// make sure that every path has a trailing slash! Consult docs/code/routing.md for more information
export const RouteConfig = {
  home: "/",
  signin: "/sign-in/",
  acceptInvite: "/accept-invite/",
  profileSettings: "/profile-settings/",
  organizationSettings: "/organization-settings/",
  uploads: "/uploads/",
  uploadsProfile: "/uploads/[profileId]/",
  bugReport: "/bug-report/",
};

export const getUploadsProfileRoute = (profileId: string) => `/uploads/${profileId}/`;
